import extension from './modules/extension/route-names'

export const EXTENSIONS = 'EXTENSIONS'

export default {
    list: EXTENSIONS,
    // Modules
    extension
}
